import i18next from 'i18next';
import React from 'react';
import { func } from 'prop-types';
import cn from 'classnames';

import { ReactComponent as ClaveUnicaLogo } from '~assets/unique.svg';

import styles from './styles.module.scss';

// Two options at the same level, each with what it involves and how long the
// evaluation takes, instead of the ClaveÚnica card plus a "manual" link.
function EvaluationChoices({ onUniqueKey, onManual }) {
  const options = [
    { id: 'automatic', handleClick: onUniqueKey, primary: true, withLogo: true },
    { id: 'manual', handleClick: onManual, primary: false }
  ];
  return (
    <div className={styles.choices}>
      {options.map(({ id, handleClick, primary, withLogo }) => (
        <button
          key={id}
          type="button"
          className={cn(styles.choice, { [styles.primary]: primary })}
          onClick={handleClick}>
          <span className={styles.choiceTexts}>
            <span className={styles.choiceTitle}>{i18next.t(`ClientFlowChoice:${id}Title`)}</span>
            {/* The time goes on the detail row so the title fits on one line on phones. */}
            <span className={styles.choiceDetailRow}>
              <span className={styles.choiceDetail}>
                {i18next.t(`ClientFlowChoice:${id}Detail`)}
                {withLogo && (
                  // The official logo keeps its colors on a white pill.
                  <span className={styles.logoPill}>
                    <ClaveUnicaLogo className={styles.choiceLogo} role="img" aria-label="ClaveÚnica" />
                  </span>
                )}
              </span>
              <span className={styles.choiceTime}>{i18next.t(`ClientFlowChoice:${id}Time`)}</span>
            </span>
          </span>
          <svg className={styles.chevron} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 6l6 6-6 6" />
          </svg>
        </button>
      ))}
    </div>
  );
}

EvaluationChoices.propTypes = {
  onManual: func,
  onUniqueKey: func
};

export default EvaluationChoices;
